import { gql } from '@apollo/client';
import {
  SURVEILLANCE_ROUTE_FULL_FRAGMENT,
  ROUTE_SEGMENT_FRAGMENT,
  ROUTE_SEGMENT_DETAIL_FRAGMENT,
} from '../fragments/surveillanceRoute';
import { NEW_ORDER } from '../fragments/orders';

// ═══════════════════════════════════════════════════════════════════
// Mutations — Timer iteration 2026-04-15
// Removed: PAUSE_SURVEILLANCE_ROUTE, RESUME_SURVEILLANCE_ROUTE, START_ROUTE_SEGMENT
// Added: LINK_ORDER_TO_SURVEILLANCE_ROUTE, UNLINK_ORDER_FROM_SURVEILLANCE_ROUTE
// Changed: FINISH_ROUTE_SEGMENT ahora lleva pkEnd/pauseCause.
// Changed: CREATE_ROUTE_SEGMENT simplificado (no lleva pkEnd ni operatorIds).
// ═══════════════════════════════════════════════════════════════════

export const CREATE_SURVEILLANCE_ROUTE = gql`
  ${SURVEILLANCE_ROUTE_FULL_FRAGMENT}
  mutation CreateSurveillanceRoute($input: NewSurveillanceRoute!) {
    createSurveillanceRoute(input: $input) {
      ...SurveillanceRouteFullFragment
    }
  }
`;

export const UPDATE_SURVEILLANCE_ROUTE = gql`
  ${SURVEILLANCE_ROUTE_FULL_FRAGMENT}
  mutation UpdateSurveillanceRoute($input: UpdateSurveillanceRoute!) {
    updateSurveillanceRoute(input: $input) {
      ...SurveillanceRouteFullFragment
    }
  }
`;

export const UPDATE_SURVEILLANCE_ROUTE_RELATIONSHIPS = gql`
  ${SURVEILLANCE_ROUTE_FULL_FRAGMENT}
  mutation UpdateSurveillanceRouteRelationships(
    $input: UpdateSurveillanceRouteRelationships!
  ) {
    updateSurveillanceRouteRelationships(input: $input) {
      ...SurveillanceRouteFullFragment
    }
  }
`;

export const SAVE_SURVEILLANCE_ROUTE = gql`
  mutation SaveSurveillanceRoute($input: SaveSurveillanceRouteInput!) {
    saveSurveillanceRoute(input: $input) {
      order {
        ...NewOrder
      }
      surveillanceRoute {
        ...SurveillanceRouteFullFragment
      }
    }
  }
  ${NEW_ORDER}
  ${SURVEILLANCE_ROUTE_FULL_FRAGMENT}
`;

export const DELETE_SURVEILLANCE_ROUTE = gql`
  mutation DeleteSurveillanceRoute($id: ID!) {
    deleteSurveillanceRoute(id: $id) {
      id
    }
  }
`;

// ═══════════════════════════════════════════════════════════════════
// MUTATIONS - CONTROL DEL RECORRIDO (Timer iteration 2026-04-15)
// pause/resume eliminadas. Solo start y finish del recorrido completo.
// ═══════════════════════════════════════════════════════════════════

export const START_SURVEILLANCE_ROUTE = gql`
  ${SURVEILLANCE_ROUTE_FULL_FRAGMENT}
  mutation StartSurveillanceRoute($input: StartSurveillanceRoute!) {
    startSurveillanceRoute(input: $input) {
      ...SurveillanceRouteFullFragment
    }
  }
`;

export const FINISH_SURVEILLANCE_ROUTE = gql`
  ${SURVEILLANCE_ROUTE_FULL_FRAGMENT}
  mutation FinishSurveillanceRoute($input: FinishSurveillanceRoute!) {
    finishSurveillanceRoute(input: $input) {
      ...SurveillanceRouteFullFragment
    }
  }
`;

// Cambios de estado manuales del RV (2026-07-20, paridad genéricas/campañas):
// el ChangeStateModal llama a la mutation SR según el estado destino — NUNCA
// UPDATE_ORDER (validador genérico ≠ máquina RV; el backend además cascadea a
// tramos dentro de su $transaction). Selección mínima {id state registerEndDate}:
// Apollo normaliza por id y actualiza la caché del detalle; el resto lo
// refresca el revalidator.
export const VALIDATE_SURVEILLANCE_ROUTE = gql`
  mutation ValidateSurveillanceRoute($id: ID!, $closeActions: Boolean) {
    validateSurveillanceRoute(id: $id, closeActions: $closeActions) {
      id
      state
      registerEndDate
    }
  }
`;

export const ANNUL_SURVEILLANCE_ROUTE = gql`
  mutation AnnulSurveillanceRoute($id: ID!) {
    annulSurveillanceRoute(id: $id) {
      id
      state
      registerEndDate
    }
  }
`;

export const REOPEN_SURVEILLANCE_ROUTE = gql`
  mutation ReopenSurveillanceRoute($id: ID!) {
    reopenSurveillanceRoute(id: $id) {
      id
      state
      registerEndDate
    }
  }
`;

// Force-close del gestor (rv-recorrido-colgado 2026-07-22): cierra un recorrido
// COLGADO eligiendo la hora real de fin. operationName contractual (mocks E2E).
export const FORCE_CLOSE_SURVEILLANCE_ROUTE = gql`
  mutation ForceCloseSurveillanceRoute($input: ForceCloseSurveillanceRoute!) {
    forceCloseSurveillanceRoute(input: $input) {
      id
      state
      registerEndDate
      forceClosedById
      forceClosedAt
    }
  }
`;

// ═══════════════════════════════════════════════════════════════════
// MUTATIONS - TIMERS (RouteSegment — Timer iteration 2026-04-15)
// ═══════════════════════════════════════════════════════════════════

export const CREATE_ROUTE_SEGMENT = gql`
  ${ROUTE_SEGMENT_FRAGMENT}
  mutation CreateRouteSegment($input: NewRouteSegment!) {
    createRouteSegment(input: $input) {
      ...RouteSegmentFragment
    }
  }
`;

/**
 * Corrección del OPERARIO sobre un tramo cerrado (spec 2026-08-15): sentido,
 * carril y descripción. Es Tablet-only en el backend.
 *
 * Estuvo retirada entre 2026-07-21 y 2026-08-15 — su único consumidor era un
 * export muerto. Vuelve con un input distinto: `description` (que escribía la
 * Order gemela, hoy vestigial) fuera; `lane` y `pauseCauseDetail` dentro.
 *
 * Gestión NO pasa por aquí: corrige con CORRECT_ROUTE_SEGMENT, que además toca
 * PK y horas.
 *
 * ⚠️ El fragment va DELANTE del `mutation`, igual que en CREATE/FINISH: es lo
 * que espera `getMainDefinition` del `OfflineQueueLink`. Con el orden al revés
 * la operación se clasificaría como query y NUNCA se encolaría sin cobertura.
 */
export const UPDATE_ROUTE_SEGMENT = gql`
  ${ROUTE_SEGMENT_FRAGMENT}
  mutation UpdateRouteSegment($input: UpdateRouteSegment!) {
    updateRouteSegment(input: $input) {
      ...RouteSegmentFragment
    }
  }
`;

export const DELETE_ROUTE_SEGMENT = gql`
  mutation DeleteRouteSegment($id: ID!) {
    deleteRouteSegment(id: $id) {
      id
    }
  }
`;

export const FINISH_ROUTE_SEGMENT = gql`
  ${ROUTE_SEGMENT_FRAGMENT}
  mutation FinishRouteSegment($input: FinishRouteSegment!) {
    finishRouteSegment(input: $input) {
      ...RouteSegmentFragment
    }
  }
`;

// V4 D2 (2026-05-07): cross-link tramo ↔ Order self-ref M:N.
// El backend escribe en `Order.segmentLinkedBasicActionOrderIDs` (basic-action)
// o `Order.segmentLinkedExternalOrderIDs` (external) + recíprocos.
// Las 3 mutations comparten input `{ segmentId, orderId }`.
export const LINK_ORDER_TO_SEGMENT = gql`
  ${ROUTE_SEGMENT_FRAGMENT}
  mutation LinkOrderToSegment($input: LinkOrderToSegment!) {
    linkOrderToSegment(input: $input) {
      ...RouteSegmentFragment
    }
  }
`;

export const LINK_EXTERNAL_ORDER_TO_SEGMENT = gql`
  ${ROUTE_SEGMENT_FRAGMENT}
  mutation LinkExternalOrderToSegment($input: LinkOrderToSegment!) {
    linkExternalOrderToSegment(input: $input) {
      ...RouteSegmentFragment
    }
  }
`;

export const UNLINK_ORDER_FROM_SEGMENT = gql`
  ${ROUTE_SEGMENT_FRAGMENT}
  mutation UnlinkOrderFromSegment($input: LinkOrderToSegment!) {
    unlinkOrderFromSegment(input: $input) {
      ...RouteSegmentFragment
    }
  }
`;

// V4 D6 (2026-05-06): cambiar pauseCause de un tramo cerrado.
// El backend reconcilia vínculos automáticamente:
// - basic → action: nada (actuación se vincula manualmente desde P15).
// - basic → external-call: marca pendingExternalLink=true.
// - action → external-call: desvincula la actuación previa, pendingExternalLink=true.
// - external-call → action: pendingExternalLink=false (sala canceló el aviso).
// - cualquiera → basic: limpia vínculos cross-link.
export const UPDATE_SEGMENT_PAUSE_CAUSE = gql`
  ${ROUTE_SEGMENT_FRAGMENT}
  mutation UpdateSegmentPauseCause($input: UpdateSegmentPauseCause!) {
    updateSegmentPauseCause(input: $input) {
      ...RouteSegmentFragment
      # QA guía S1 (15-oct): al pasar a «Aviso» el back intenta ligarlo solo;
      # con esto el aviso dice a qué OT (o que queda pendiente).
      linkedExternalOrder {
        id
        roid
        type
        state
      }
    }
  }
`;

// Corrección de gestión de un tramo cerrado (spec 2026-07-31): PK inicial, PK
// final, sentido, carril y horas. Los campos ausentes no se tocan; el backend
// valida solapamiento contra los tramos vecinos en el tiempo y exige el
// recorrido pausado o pendiente de validación.
export const CORRECT_ROUTE_SEGMENT = gql`
  ${ROUTE_SEGMENT_FRAGMENT}
  mutation CorrectRouteSegment($input: CorrectRouteSegment!) {
    correctRouteSegment(input: $input) {
      ...RouteSegmentFragment
    }
  }
`;

// «Registrar parada» (spec 2026-10-06): gestión parte un tramo cerrado por las
// paradas que la patrulla no pausó. Devuelve las piezas con el fragment de
// DETALLE (vínculos y rastro) y qué pasó con el aviso de cada una.
export const SPLIT_ROUTE_SEGMENT = gql`
  ${ROUTE_SEGMENT_DETAIL_FRAGMENT}
  mutation SplitRouteSegment($input: SplitRouteSegment!) {
    splitRouteSegment(input: $input) {
      segments {
        ...RouteSegmentDetailFragment
      }
      links {
        segmentId
        reason
        order {
          id
          roid
          type
          state
        }
      }
    }
  }
`;

// Deshace la última parada registrada en un tramo (cualquier pieza sirve).
export const UNDO_SEGMENT_SPLIT = gql`
  ${ROUTE_SEGMENT_DETAIL_FRAGMENT}
  mutation UndoSegmentSplit($segmentId: ID!) {
    undoSegmentSplit(segmentId: $segmentId) {
      ...RouteSegmentDetailFragment
    }
  }
`;

// Transferir tramo (2026-10-07): mueve un tramo cerrado a otro recorrido.
export const TRANSFER_ROUTE_SEGMENT = gql`
  ${ROUTE_SEGMENT_DETAIL_FRAGMENT}
  mutation TransferRouteSegment($input: TransferRouteSegment!) {
    transferRouteSegment(input: $input) {
      roid
      unlinkedBasicOrderIds
      routeOrderIds
      zeroLengthBasics {
        id
        roid
      }
      segment {
        ...RouteSegmentDetailFragment
      }
    }
  }
`;

/**
 * «Mover tramos» (plan 2026-10-15 § 3): un rango seguido de tramos a otro
 * recorrido (existente o nuevo) en una transacción. De oficina: va con
 * `skipOfflineQueue` (ver `useSurveillanceRoutes.moveSegments`).
 */
export const MOVE_ROUTE_SEGMENTS = gql`
  mutation MoveRouteSegments($input: MoveRouteSegments!) {
    moveRouteSegments(input: $input) {
      sourceRouteId
      sourceRoid
      targetRouteId
      targetRoid
      movedCount
      sourceAnnulled
      movedBasicOrderIds
      zeroLengthBasics {
        id
        roid
      }
    }
  }
`;

// ═══════════════════════════════════════════════════════════════════
// MUTATIONS - GPS TRACKING
// ═══════════════════════════════════════════════════════════════════

export const ADD_GPS_POINT = gql`
  ${SURVEILLANCE_ROUTE_FULL_FRAGMENT}
  mutation AddGpsPoint($input: AddGpsPoint!) {
    addGpsPoint(input: $input) {
      ...SurveillanceRouteFullFragment
    }
  }
`;

/**
 * Fix 2026-07-20: el flush de GPS es fire-and-forget (el caller de
 * useSurveillanceRouteGpsTracking ignora el resultado), pero la mutación
 * devolvía el SurveillanceRouteFullFragment ENTERO: payload inútil en cada
 * flush y, peor, su gpsPoints(simplified) parcial (~25 puntos) MACHACABA en
 * la caché Apollo el track completo ya cargado (warning "Cache data may be
 * lost when replacing the gpsPoints field" + el mapa perdía puntos hasta el
 * siguiente refetch). Solo pedimos `id` — lo mínimo para que Apollo
 * identifique la entidad sin tocar ningún otro campo cacheado.
 */
export const ADD_GPS_POINTS_BATCH = gql`
  mutation AddGpsPointsBatch($input: AddGpsPointsBatch!) {
    addGpsPointsBatch(input: $input) {
      id
    }
  }
`;

// Cross-link 3 (2026-09-22): recorrido ↔ OT externa, N:M e idempotente. Se
// devuelve el recorrido con sus vínculos para que Apollo refresque el detalle
// por id sin refetch.
export const LINK_ORDER_TO_SURVEILLANCE_ROUTE = gql`
  mutation LinkOrderToSurveillanceRoute($input: LinkOrderToSurveillanceRoute!) {
    linkOrderToSurveillanceRoute(input: $input) {
      id
      linkedExternalOrders {
        order {
          id
          roid
          type
          state
          actionId
        }
        source
        linkedAt
        viaOrderId
        segments {
          id
          indexType
          pauseCause
          endDate
        }
      }
    }
  }
`;

export const UNLINK_ORDER_FROM_SURVEILLANCE_ROUTE = gql`
  mutation UnlinkOrderFromSurveillanceRoute(
    $input: LinkOrderToSurveillanceRoute!
  ) {
    unlinkOrderFromSurveillanceRoute(input: $input) {
      id
      linkedExternalOrders {
        order {
          id
          roid
          type
          state
          actionId
        }
        source
        linkedAt
        viaOrderId
        segments {
          id
          indexType
          pauseCause
          endDate
        }
      }
    }
  }
`;

/**
 * «Recalcular con el recorrido» (12-oct): el back quita las marcas de «puesto
 * a mano» del horario de la básica y vuelve a calcular inicio y fin desde el
 * hueco actual de su tramo (contrato de #157; errores
 * `BASIC_SCHEDULE_NOT_A_BASIC` y `BASIC_SCHEDULE_NOT_LINKED`).
 */
export const RECALCULATE_BASIC_SCHEDULE = gql`
  mutation RecalculateBasicSchedule($orderId: ID!) {
    recalculateBasicSchedule(orderId: $orderId) {
      id
      registerInitDate
      registerEndDate
    }
  }
`;
